import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import {getPhoneRuleObj} from "@/plugins/vee-validate";

export default class TelephoneBidModal extends BaseModel {
  paddle_number = null;
  preferred_clerk_uuid = null;
  language_uuid = null;
  contact_number = null

  static TRANSLATABLE_FIELDS = [];

  rules = {
    paddle_number: 'required',
    contact_number: getPhoneRuleObj(),
  };

  attributeLabels = {
    paddle_number: i18n.t('Paddle Number'),
    lot_no: i18n.t('Lot'),
    cover_amount: i18n.t('Cover Amount'),
    language_uuid: i18n.t('Language'),
    preferred_clerk_uuid: i18n.t('Preferred Clerk'),
    contact_number: i18n.t('Contact Number'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(TelephoneBidModal);
